import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import useServicesData from '../../Hooks/useServicesData';
import useStudentsReviews from '../../Hooks/useStudentsReviews';
import Banner from '../Banner/Banner';
import BtnLink from '../CustomLink/BtnLink';
import Service from '../Service/Service';
import './Home.css'




const Home = () => {
  const [services] = useServicesData();
 const [reviews] = useStudentsReviews();

 //for making random Reviews
 function checkRandom(length, array){
  const newRandomArray = [];
  for(let i = 0; i<length; i++){
      const randomIndex = Math.floor(Math.random()*length);
      
      if(newRandomArray.includes(array[randomIndex]) === false){
          newRandomArray.push(array[randomIndex]);
      }
     
  }
  return newRandomArray;
}

const randomReviews = checkRandom(reviews.length, reviews);
const topReviews = randomReviews.slice(0, 3);

const randomServices = checkRandom(services.length, services);
const topServices = randomServices.slice(0, 6);

  return (
    <div className='m-2'>
      <div className='shadow'><Banner></Banner></div>
      <div className='my-5'>
        <h1 className='bg-my p-2 rounded-3 text-center text-white shadow'> My Services for my Students</h1>
        <p className='text-center  p-2 text-warning'><small className='bg-dark p-2 rounded shadow'>( Here, You can see Randomly top 6 Services )</small></p>
        <Row xs={1} md={2} lg={3} className="g-4">
          {
           topServices.map(service => <Service key={service.id} service={service}></Service>)
          }
        </Row>

        <div className='btn-position d-flex justify-content-center my-5'>  <BtnLink className="px-5 bg-danger fw-bolder" to="/services"> See All Services</BtnLink></div>
      </div>

      <div>
      <h1 className='bg-my p-2 rounded-3 text-center text-white shadow'>My Students Reviews</h1>
      <p className='text-center  p-2 text-warning'><small className='bg-dark p-2 rounded shadow'>( Here, You can see Random reviews from my students about me )</small></p> 
          <div>
            
    <Row xs={1} md={2} lg={3} className="g-4">
    {
        topReviews.map( review =>  <Col>
            <Card className='h-100 shadow'>
            <div className='d-flex justify-content-center align-items-left flex-column'>
            <div className='d-flex justify-content-around align-items-center my-2'> <img className='review-img' src={review.img}  alt="profile-pic"/>   <span className='ms-3 fs-5 fw-bold ratting'>{`Ratting: ${review.rating}`}</span> </div>
             <span className='ms-3 fs-3 fw-bold text-primary'>{review.name}</span>
            </div>
              <Card.Body>
                <Card.Title>
                     <div className='d-flex justify-content-center'>
                     
                          
                     </div>
                </Card.Title>
                <Card.Text>
                 {review.reviewText}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>)
}</Row>
 <div className='btn-position d-flex justify-content-center my-5'>  <BtnLink className="px-5 bg-danger fw-bolder" to="/reviews"> See All Reviews</BtnLink></div>
          </div>

      </div>

    </div>
  );
};

export default Home;